const getFilteredFeedsByBrand = (selectedBrand, feeds) =>
  selectedBrand === 'all'
    ? feeds
    : feeds.filter(feed => feed.groupId === selectedBrand)

export default getFilteredFeedsByBrand
